var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27212 23.9918C1.90929 24.6143 1.90929 25.3837 2.27212 26.0062L12.7638 44.0052C13.1221 44.6199 13.7801 44.998 14.4916 44.998H35.5082C36.2198 44.998 36.8778 44.6199 37.2361 44.0052L47.7278 26.0062C48.0906 25.3837 48.0906 24.6143 47.7278 23.9918L37.2361 5.99281C36.8778 5.37806 36.2198 5 35.5082 5H14.4917C13.7801 5 13.1221 5.37806 12.7638 5.99281L2.27212 23.9918ZM24.9998 38.3333C32.511 38.3333 38.6001 32.3641 38.6001 25.0006C38.6001 17.6372 32.511 11.668 24.9998 11.668C17.4885 11.668 11.3994 17.6372 11.3994 25.0006C11.3994 32.3641 17.4885 38.3333 24.9998 38.3333Z",
    fill: "#EB4848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.747 28.3567L23.3041 18.9782C23.1442 17.9388 23.9484 17.0015 25 17.0015C26.0516 17.0015 26.8558 17.9388 26.6959 18.9782L25.253 28.3567C25.2085 28.6462 24.7915 28.6462 24.747 28.3567Z",
    fill: "#EB4848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31.5015C26.5 32.3265 25.825 33.0015 25 33.0015C24.175 33.0015 23.5 32.3265 23.5 31.5015C23.5 30.6765 24.175 30.0015 25 30.0015C25.825 30.0015 26.5 30.6765 26.5 31.5015Z",
    fill: "#EB4848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsError);
export default __webpack_public_path__ + "static/media/bs-error.e190094be13e81354cd0d084b107ae93.svg";
export { ForwardRef as ReactComponent };